class CollectionDescriptionExpandable extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abort;

  connectedCallback() {
    if (this.dataset.initialized === "true") return;
    this.dataset.initialized = "true";

    const content = this.querySelector('[data-ref="content"]');
    const toggle = this.querySelector('[data-ref="toggle"]');
    const labelMore = this.querySelector('[data-ref="labelMore"]');
    const labelLess = this.querySelector('[data-ref="labelLess"]');

    if (!(content instanceof HTMLElement) || !(toggle instanceof HTMLButtonElement)) return;

    this.#abort = new AbortController();
    const { signal } = this.#abort;

    const collapsedHeight = this.#getCollapsedHeight();

    const applyCollapsed = () => {
      this.dataset.expanded = "false";
      content.style.maxHeight = `${collapsedHeight}px`;
      toggle.setAttribute("aria-expanded", "false");
      if (labelMore instanceof HTMLElement) labelMore.hidden = false;
      if (labelLess instanceof HTMLElement) labelLess.hidden = true;
    };

    const applyExpanded = () => {
      this.dataset.expanded = "true";
      content.style.maxHeight = `${content.scrollHeight}px`;
      toggle.setAttribute("aria-expanded", "true");
      if (labelMore instanceof HTMLElement) labelMore.hidden = true;
      if (labelLess instanceof HTMLElement) labelLess.hidden = false;
    };

    const syncToggleVisibility = () => {
      content.style.maxHeight = "none";
      const needsToggle = content.scrollHeight > collapsedHeight + 8;

      if (!needsToggle) {
        toggle.hidden = true;
        content.style.maxHeight = "none";
        this.dataset.expanded = "true";
        return;
      }

      toggle.hidden = false;
      applyCollapsed();
    };

    syncToggleVisibility();

    toggle.addEventListener(
      "click",
      () => {
        if (this.dataset.expanded === "true") {
          applyCollapsed();
        } else {
          applyExpanded();
        }
      },
      { signal },
    );

    window.addEventListener(
      "resize",
      () => {
        if (this.dataset.expanded !== "true") {
          syncToggleVisibility();
          return;
        }

        content.style.maxHeight = "none";
        content.style.maxHeight = `${content.scrollHeight}px`;
      },
      { signal },
    );
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  /** @returns {number} */
  #getCollapsedHeight() {
    const mobile = parseInt(this.dataset.collapsedHeightMobile || "120", 10);
    const desktop = parseInt(this.dataset.collapsedHeight || "160", 10);
    const breakpoint = 768;

    return window.matchMedia(`(min-width: ${breakpoint}px)`).matches ? desktop : mobile;
  }
}

if (!customElements.get("collection-description-expandable")) {
  customElements.define("collection-description-expandable", CollectionDescriptionExpandable);
}
